module.exports = __webpack_public_path__ + "static/media/arrow-right-action.d2340dcf.svg";